define([], function(){
    return {
        PageReady: 'page-ready',
        UpdateMemberInfo: 'update-member-info'
    };
});


//////////////////
// WEBPACK FOOTER
// ..m/common/events.js
// module id = 119
// module chunks = 0